import { handleActions } from 'redux-actions';

import { actionTypes, PARTITION, ACTION_PREFIX } from './constants';
import { Context } from '../../types';
import { getActionOptions } from '../../lib/reduxActionsUtils';

export type ReduxState = {
  intentId: string | undefined;
  checkOutId: string | any;
  context: Context | undefined;
};

const initialState: ReduxState = {
  context: Context.checkout,
  checkOutId: undefined,
  intentId: undefined,
};

const reducer = handleActions(
  {
    [actionTypes.SET_INTENT_ID]: (state: any, { payload }) => ({
      ...state,
      intentId: payload,
      context: Context.linkAccount,
    }),
    [actionTypes.SET_CHECKOUT_ID]: (state: any, { payload }) => ({
      ...state,
      checkOutId: payload,
      context: Context.checkout,
    }),
  },
  initialState,
  getActionOptions(ACTION_PREFIX)
);

export default {
  [PARTITION]: reducer,
};
